<template>
  <v-alert
  v-if="notification !== undefined"
  dismissible
  type="success">
      {{ notification }}
    </v-alert>
</template>
<script>
import { wantBind } from '@/store'

export default {
  computed: {
    notification: function () {
      return this.$store.getters['notification/getText']()
    },
  },
  mounted: function () {
    wantBind(() => { this.$store.dispatch('notification/bindNotification') })
  },
}
</script>
